/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A user assigned to a claim via claim_access.
 * @export
 * @interface ClaimAssignee
 */
export interface ClaimAssignee {
    /**
     * The ID of the claim_access share record (used for revoke)
     * @type {number}
     * @memberof ClaimAssignee
     */
    shareId: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimAssignee
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimAssignee
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimAssignee
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimAssignee
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimAssignee
     */
    accessLevel: ClaimAssigneeAccessLevelEnum;
    /**
     * Claim modules hidden from this assignee in the claim detail UI.
     * @type {Array<string>}
     * @memberof ClaimAssignee
     */
    blockedModules?: Array<ClaimAssigneeBlockedModulesEnum>;
}


/**
 * @export
 */
export const ClaimAssigneeAccessLevelEnum = {
    Ro: 'ro',
    Rw: 'rw'
} as const;
export type ClaimAssigneeAccessLevelEnum = typeof ClaimAssigneeAccessLevelEnum[keyof typeof ClaimAssigneeAccessLevelEnum];

/**
 * @export
 */
export const ClaimAssigneeBlockedModulesEnum = {
    Comparisons: 'comparisons',
    Documents: 'documents',
    Photos: 'photos',
    Links: 'links',
    Tasks: 'tasks',
    Supplements: 'supplements',
    Forms: 'forms',
    Financials: 'financials',
    Emails: 'emails',
    Notes: 'notes'
} as const;
export type ClaimAssigneeBlockedModulesEnum = typeof ClaimAssigneeBlockedModulesEnum[keyof typeof ClaimAssigneeBlockedModulesEnum];


/**
 * Check if a given object implements the ClaimAssignee interface.
 */
export function instanceOfClaimAssignee(value: object): value is ClaimAssignee {
    if (!('shareId' in value) || value['shareId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('accessLevel' in value) || value['accessLevel'] === undefined) return false;
    return true;
}

export function ClaimAssigneeFromJSON(json: any): ClaimAssignee {
    return ClaimAssigneeFromJSONTyped(json, false);
}

export function ClaimAssigneeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimAssignee {
    if (json == null) {
        return json;
    }
    return {
        
        'shareId': json['shareId'],
        'userId': json['userId'],
        'name': json['name'],
        'email': json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'accessLevel': json['accessLevel'],
        'blockedModules': json['blockedModules'] == null ? undefined : json['blockedModules'],
    };
}

export function ClaimAssigneeToJSON(json: any): ClaimAssignee {
    return ClaimAssigneeToJSONTyped(json, false);
}

export function ClaimAssigneeToJSONTyped(value?: ClaimAssignee | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shareId': value['shareId'],
        'userId': value['userId'],
        'name': value['name'],
        'email': value['email'],
        'phone': value['phone'],
        'accessLevel': value['accessLevel'],
        'blockedModules': value['blockedModules'],
    };
}

